// react-device-detect 대체 유틸리티

const userAgent = typeof navigator !== 'undefined' ? navigator.userAgent.toLowerCase() : '';

export const isMobile = /android|webos|iphone|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
export const isTablet = /ipad|android(?!.*mobile)/i.test(userAgent) || (typeof navigator !== 'undefined' && navigator.maxTouchPoints > 1 && /macintosh/i.test(userAgent));
export const isBrowser = !isMobile && !isTablet;

// BrowserView, MobileView 컴포넌트 대체
export const BrowserView = ({ children }) => {
  if (isBrowser) return children;
  return null;
};

export const MobileView = ({ children }) => {
  if (isMobile) return children;
  return null;
};

export const TabletView = ({ children }) => {
  if (isTablet) return children;
  return null;
};
